<template>
  <div class="calendar">
    <div class="days" @click="first()">
      <p class="highlight">Lundi</p>
      <h1>4</h1>
      <p class="month">Décembre</p>
      <img src="../../assets/Gipsy/circle.png" class="circle" v-if="displayFirst" />
    </div>
    <div class="days" @click="second()">
      <p class="highlight">Mardi</p>
      <h1>5</h1>
      <p class="month">Décembre</p>
      <img
        src="../../assets/Gipsy/circle.png"
        class="circle"
        v-if="displaySecond"
        @click="second()"
      />
    </div>
    <div class="days" @click="third()">
      <p class="highlight">Mercredi</p>
      <h1>6</h1>
      <p class="month">Décembre</p>
      <img src="../../assets/Gipsy/circle.png" class="circle" v-if="displayThird" />
    </div>
    <div class="days" @click="fourth()">
      <p class="highlight">Jeudi</p>
      <h1>7</h1>
      <p class="month">Décembre</p>
      <img src="../../assets/Gipsy/circle.png" class="circle" v-if="displayFourth" />
    </div>
    <div class="days" @click="fifth()">
      <p class="highlight">Vendredi</p>
      <h1>8</h1>
      <p class="month">Décembre</p>
      <img src="../../assets/Gipsy/circle.png" class="circle" v-if="displayFifth" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Calendar",
  data() {
    return {
      displayFirst: false,
      displaySecond: false,
      displayThird: false,
      displayFourth: false,
      displayFifth: false
    };
  },
  methods: {
    first() {
      this.displayFirst = true;
      this.displaySecond = false;
      this.displayThird = false;
      this.displayFourth = false;
      this.displayFifth = false;
      this.$emit("chooseDay", 1);
      this.$emit("toggleOne");
    },
    second() {
      this.displayFirst = false;
      this.displaySecond = true;
      this.displayThird = false;
      this.displayFourth = false;
      this.displayFifth = false;
      this.$emit("chooseDay", 2);
      this.$emit("toggleTwo");
    },
    third() {
      this.displayFirst = false;
      this.displaySecond = false;
      this.displayThird = true;
      this.displayFourth = false;
      this.displayFifth = false;
      this.$emit("chooseDay", 3);
      this.$emit("toggleThree");
    },
    fourth() {
      this.displayFirst = false;
      this.displaySecond = false;
      this.displayThird = false;
      this.displayFourth = true;
      this.displayFifth = false;
      this.$emit("chooseDay", 4);
      this.$emit("toggleFour");
    },
    fifth() {
      this.displayFirst = false;
      this.displaySecond = false;
      this.displayThird = false;
      this.displayFourth = false;
      this.displayFifth = true;
      this.$emit("chooseDay", 5);
      this.$emit("toggleFive");
    }
  }
};
</script>
<style scoped>
h1 {
  font-family: "Libre Caslon Text", serif;
  font-size: 18px;
}
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.calendar {
  display: inline-grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  width: 100%;
}
.highlight {
  background: rgb(80, 80, 80);
  color: rgb(230, 230, 230);
  line-height: 2em;
  font-weight: bold;
  margin-block-start: 0;
  margin-block-end: 0;
}
.days {
  margin: 4px;
  border: 2px solid rgb(80, 80, 80);
  position: relative;
  overflow: hidden;
}
.days h1 {
  font-size: 2em;
  line-height: 1.4em;
  margin: 0;
}
.days:hover {
  opacity: 0.85;
  cursor: pointer;
}
.month {
  font-weight: bold;
  margin-block-start: 0;
  margin-block-end: 8px;
}
.circle {
  width: 80%;
  position: absolute;
  bottom: 13%;
  left: 10%;
}
</style>